import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import Logo from "@/components/Logo";

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      {/* Final CTA Banner */}
      <section className="py-24 md:py-28 bg-foreground">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-5xl font-extralight text-background tracking-tight">
              {t("footer.cta.title")}
            </h2>
            <p className="mt-6 text-background/60 max-w-md mx-auto text-base font-light">
              {t("footer.cta.subtitle")}
            </p>
            <div className="mt-10 flex flex-wrap gap-3 justify-center">
              <Button
                size="lg"
                className="bg-background text-foreground hover:bg-background/90 rounded-full px-10 text-sm font-light tracking-wide gap-2 shadow-none"
                onClick={() => navigate("/create")}
              >
                {t("nav.createCardCta")}
                <ArrowRight size={16} strokeWidth={1.5} />
              </Button>
              <Button
                size="lg"
                variant="ghost"
                className="rounded-full px-10 text-sm font-light tracking-wide text-background hover:bg-background/10 hover:text-background"
                onClick={() => navigate("/cards/birthday")}
              >
                {t("footer.cta.secondary")}
              </Button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-foreground text-background py-20 border-t border-background/5">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-12">
            <div>
              <Logo size="sm" />
              <p className="mt-4 text-xs font-light opacity-40 leading-relaxed">
                {t("footer.description")}
              </p>
            </div>
            <div>
              <h4 className="text-[10px] font-light mb-6 opacity-40 uppercase tracking-[0.2em]">
                {t("footer.product")}
              </h4>
              <ul className="space-y-3 text-xs font-light opacity-40">
                <li>
                  <a href="#how-it-works" className="hover:opacity-100 transition-opacity">
                    {t("nav.howItWorks")}
                  </a>
                </li>
                <li>
                  <a href="#gift-options" className="hover:opacity-100 transition-opacity">
                    {t("nav.giftOptions")}
                  </a>
                </li>
                <li>
                  <a href="#occasions" className="hover:opacity-100 transition-opacity">
                    {t("nav.occasions")}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-[10px] font-light mb-6 opacity-40 uppercase tracking-[0.2em]">
                {t("megaMenu.occasions")}
              </h4>
              <ul className="space-y-3 text-xs font-light opacity-40">
                <li>
                  <a href="/cards/birthday" className="hover:opacity-100 transition-opacity">
                    {t("occasions.birthday")}
                  </a>
                </li>
                <li>
                  <a href="/cards/farewell" className="hover:opacity-100 transition-opacity">
                    {t("occasions.farewell")}
                  </a>
                </li>
                <li>
                  <a href="/cards/thank-you" className="hover:opacity-100 transition-opacity">
                    {t("occasions.thankYou")}
                  </a>
                </li>
                <li>
                  <a href="/cards/wedding" className="hover:opacity-100 transition-opacity">
                    {t("occasions.wedding")}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-[10px] font-light mb-6 opacity-40 uppercase tracking-[0.2em]">
                {t("footer.support")}
              </h4>
              <ul className="space-y-3 text-xs font-light opacity-40">
                <li>
                  <a href="#faq" className="hover:opacity-100 transition-opacity">
                    {t("nav.faq")}
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:opacity-100 transition-opacity">
                    {t("footer.contactUs")}
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:opacity-100 transition-opacity">
                    {t("footer.privacyPolicy")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-20 pt-8 border-t border-background/5 text-center text-[10px] font-light opacity-20 tracking-wide">
            {t("footer.copyright")}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
